import { Box, Stack, Typography } from '@mui/material';

import { radius } from '@karehero/llama/theme/radius';

import StatusBar from '@/designs-dev/device/StatusBar';
import HomeIndicator from '@/designs-dev/device/HomeIndicator';
import ScreenRoot from '@/components/wrapped/ScreenRoot';

// A screen this flow has to have and has not drawn yet. Grey ground, dashed
// card, the word Placeholder over it: it holds a slot on the flows page without
// pretending to be a design, which is what the self branch and the consent
// refusal were both doing by hand.
//
// No onward action. It is the end of a branch on a flows page, not a step.
const PlaceholderScreen = ({
  title,
  note,
}: {
  title: string;
  /** What has to be decided before this can be drawn. */
  note: string;
}) => (
  <ScreenRoot sx={{ bgcolor: 'custom.neutral.300' }}>
    <StatusBar />

    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
      }}
    >
      <Stack
        sx={{
          width: '100%',
          p: 3,
          textAlign: 'center',
          border: 1,
          borderStyle: 'dashed',
          borderColor: 'custom.neutral.500',
          borderRadius: `${radius.md}px`,
        }}
        spacing={1}
      >
        <Typography sx={{ color: 'text.secondary' }} variant='overline'>
          Placeholder
        </Typography>
        <Typography variant='h2'>{title}</Typography>
        <Typography sx={{ color: 'text.secondary' }} variant='body2'>
          {note}
        </Typography>
      </Stack>
    </Box>

    <HomeIndicator />
  </ScreenRoot>
);

export default PlaceholderScreen;
